<template>
    <div data-aos="fade-up">
        <v-container>
            <v-card
            v-if="type === 'post/carousel' || type === 'reel'"
            class="mx-auto"            
            outlined
            color="#000000"
            style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title style="text-align:center;"><v-icon style="color:#E1306C;" large >mdi-instagram</v-icon>  {{post.title}} - @{{post.name}}</v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.engagement !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Total Interactions</span><br/>
                                    <span class="IG-reaction-value">{{post.engagement | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                            
                                <div v-if="post.likes !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.likes | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comments !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comments | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.saved && post.saved !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.saved | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares && post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.views && post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.plays && post.plays !== '0h:0m:0s' && post.plays !== 'h:m:s'" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Watch Time</span><br/>
                                    <span class="IG-reaction-value">{{showTikTokPlayTime(post.plays) | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watches && post.watches !== '0s'" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Average Watch Time</span><br/>
                                    <span class="IG-reaction-value">{{post.watches | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col v-if="post.type !== 'story'" col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-html="igPost"></div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
            v-else-if="type === 'story'"
            class="mx-auto"            
            outlined
            color="#000000"
            style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title style="text-align:center;"><v-icon style="color:#E1306C;" large >mdi-instagram</v-icon>  {{post.title}} - @{{post.name}}</v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.storyTotalInteractions !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                  <span class="IG-reaction-title">Total Interactions</span><br/>
                                  <span class="IG-reaction-value">{{post.storyTotalInteractions | thousandSeprator}}</span>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.link_clicks !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Link Clicks</span><br/>
                                    <span class="IG-reaction-value">{{post.link_clicks | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.replies !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Replies</span><br/>
                                    <span class="IG-reaction-value">{{post.replies | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.sticker_taps !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Sticker Taps</span><br/>
                                    <span class="IG-reaction-value">{{post.sticker_taps | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                          <video width="350" controls v-if="MEDIA_URL_TYPE === 'video'">
                            <source :src="POST_URL" type="video/mp4">
                            Your browser does not support HTML5 video.
                          </video>
                          <img style="max-width:350px" v-else-if="MEDIA_URL_TYPE === 'image'" :src="POST_URL" />
                          <gDrive-post-view :url="POST_URL" v-else-if="MEDIA_URL_TYPE === 'driveView'" :darkTheme="true" />
                          <custom-media
                            :className="getMedia(post).className"
                            :type="getMedia(post).type"
                            :publicID="getMedia(post).publicID"
                            :videoID="getMedia(post).videoID"
                            :URL="getMedia(post).URL"
                            :width="getMedia(post).width"
                            :height="getMedia(post).height"
                            :trans="getMedia(post).trans"
                            v-else-if="MEDIA_URL_TYPE === 'cld'"
                          />
                          <iframe class="media-iframe" height="100%" :src="POST_URL" v-else-if="MEDIA_URL_TYPE === 'iframe'" allowFullScreen></iframe>
                          <div style="margin-top:150px;" v-else>
                            <v-alert width="350">
                              Media type unsupported!
                            </v-alert>
                          </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'tiktok'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
              >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title style="text-align:center;"><img src='/static/img/tik-tok-pink.png' width="36px" />  {{post.title}} - @{{post.name}}</v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.engagement !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Total Interactions</span><br/>
                                    <span class="IG-reaction-value">{{post.engagement | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                            
                                <div v-if="post.likes !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.likes | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comments !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comments | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.saved && post.saved !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.saved | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares && post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.plays !== 0 && post.plays !== '0h:0m:0s'" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Total Play Time</span><br/>
                                    <span class="IG-reaction-value">{{showTikTokPlayTime(post.plays) | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watches !== 0 && post.watches !== '0s'" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Average Watch Time</span><br/>
                                    <span class="IG-reaction-value">{{post.watches | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watchedFullVideo !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Watched Full Video</span><br/>
                                    <span class="IG-reaction-value">{{post.watchedFullVideo | thousandSeprator}}%</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.photo_views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Photo Views</span><br/>
                                    <span class="IG-reaction-value">{{post.photo_views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="tikTokPost">
                              <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                                <iframe :src="tikTokPost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                              </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'youtube'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
              >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title class="d-flex" style="text-align:center;">
                      <i class="fab fa-youtube pr-3" style="font-size:36px;color:#dd2476"></i> 
                      <div>{{post.title}} - @{{post.name}} </div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                         
                                <div v-if="post.likes !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.likes | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comments !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comments | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="youtubePost">
                              <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                                <iframe :src="youtubePost" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                              </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'facebook'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
              >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title class="d-flex" style="text-align:center;">
                      <div>{{post.title}} - @{{post.name}} </div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                         
                                <div v-if="post.like_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.like_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comment_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comment_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.bookmarks !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.bookmarks | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="post.url">
                              <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                                <iframe :src="getFbPost(post.url)"
                                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                  allowfullscreen="true"
                                  scrolling="no"
                                  style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;"></iframe>
                              </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'xhs'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title class="d-flex" style="text-align:center;">
                      <div>{{post.title}} - @{{post.name}} </div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach && post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                         
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watches !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Watches</span><br/>
                                    <span class="IG-reaction-value">{{post.watches | thousandSeprator}}s</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.like_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.like_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comment_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comment_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.bookmarks !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.bookmarks | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="post.url">
                              <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                                <iframe :src="post.url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                              </div> -->
                              <custom-media
                                :className="getMedia(post).className"
                                :type="getMedia(post).type"
                                :publicID="getMedia(post).publicID"
                                :videoID="getMedia(post).videoID"
                                :URL="getMedia(post).URL"
                                :width="getMedia(post).width"
                                :height="getMedia(post).height"
                                :trans="getMedia(post).trans"
                                :download="false"
                              />
                              <!-- <btn-download :url="post.xhsLink" label="View on XHS" noBlock="true" noIcon="true" v-if="post.xhsLink"></btn-download> -->
                              <div class="d-flex" style="justify-content:center;margin-top:10px;">
                                <v-btn
                                  small
                                  color="secondary"
                                  @click="download(getMedia(post).URL)"
                                  style="margin-right:5px"
                                >
                                  Download
                                  <v-icon right>mdi-download</v-icon>
                                </v-btn>
                                <v-btn
                                  small
                                  color="secondary"
                                  @click="download(post.xhsLink)"
                                >
                                  View on XHS
                                  <v-icon right>mdi-file-outline</v-icon>
                                </v-btn>
                              </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'lemon'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title class="d-flex" style="text-align:center;">
                      <div>{{post.title}} - @{{post.name}} </div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach && post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                         
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watches !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Watches</span><br/>
                                    <span class="IG-reaction-value">{{post.watches | thousandSeprator}}s</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.like_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.like_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comment_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comment_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.bookmarks !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.bookmarks | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="post.url">
                              <!-- <div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 177.7778%; padding-top: 90px;">
                                <iframe :src="post.url" allow="fullscreen" style="position: absolute; top: 0px; left: 0px; height: 100%; width: 100%;border:none;"></iframe>
                              </div> -->
                              <custom-media
                                :className="getMedia(post).className"
                                :type="getMedia(post).type"
                                :publicID="getMedia(post).publicID"
                                :videoID="getMedia(post).videoID"
                                :URL="getMedia(post).URL"
                                :width="getMedia(post).width"
                                :height="getMedia(post).height"
                                :trans="getMedia(post).trans"
                                :download="false"
                              />
                              <div class="d-flex" style="justify-content:center;margin-top:10px;">
                                <v-btn
                                  small
                                  color="secondary"
                                  @click="download(getMedia(post).URL)"
                                  style="margin-right:5px"
                                >
                                  Download
                                  <v-icon right>mdi-download</v-icon>
                                </v-btn>
                                <v-btn
                                  small
                                  color="secondary"
                                  @click="download(post.lemonLink)"
                                >
                                  View on Lemon8
                                  <v-icon right>mdi-file-outline</v-icon>
                                </v-btn>
                              </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'linkedin'"
              class="mx-auto"
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar dark color="#212121">
                    <v-toolbar-title class="d-flex align-center" style="text-align:center;">
                      <v-icon color="#0A66C2" class="mr-2">mdi-linkedin</v-icon>
                      <div>LinkedIn Post - @{{post.name}}</div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="12" md="5" lg="5">
                            <div class="linkedin-insights">
                                <div v-if="hasPositiveMetric(post.impressions)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Impressions</span><br/>
                                    <span class="IG-reaction-value">{{(post.impressions || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="hasPositiveMetric(post.reach)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Members reached</span><br/>
                                    <span class="IG-reaction-value">{{(post.reach || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="hasPositiveMetric(post.like_count)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Reactions</span><br/>
                                    <span class="IG-reaction-value">{{(post.like_count || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="hasPositiveMetric(post.comment_count)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{(post.comment_count || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="hasPositiveMetric(post.shares)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Reposts</span><br/>
                                    <span class="IG-reaction-value">{{(post.shares || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="hasPositiveMetric(post.saved != null ? post.saved : post.bookmarks)" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Saves</span><br/>
                                    <span class="IG-reaction-value">{{(post.saved || post.bookmarks || 0) | thousandSeprator}}</span>
                                    <v-divider color="#0A66C2" width="250px" class="mx-auto"></v-divider>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="7" lg="7" align="center">
                            <iframe
                              v-if="getLinkedInEmbedUrl(post.url)"
                              class="linkedin-post-embed"
                              :src="getLinkedInEmbedUrl(post.url)"
                              :title="`LinkedIn post by ${post.name}`"
                              width="100%"
                              height="560"
                              frameborder="0"
                              allowfullscreen
                            ></iframe>
                            <v-alert v-else width="500">This LinkedIn post cannot be embedded.</v-alert>
                            <v-btn small color="secondary" :href="post.url" target="_blank" class="mt-3">
                              View on LinkedIn
                              <v-icon right>mdi-linkedin</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'twitter'"
              class="mx-auto"
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar dark color="#212121">
                    <v-toolbar-title class="d-flex align-center" style="text-align:center;">
                      <img src="/static/img/x-logo.svg" width="24px" class="mr-2" style="filter: invert(1);" alt="" aria-hidden="true" />
                      <div class="twitter-report-title-text">X (Twitter) Post · @{{post.name}}</div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="12" md="5" lg="5">
                            <div class="twitter-insights">
                                <div v-if="twitterMetric(post, 'impressions') > 0" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Impressions</span><br/>
                                    <span class="IG-reaction-value">{{twitterMetric(post, 'impressions') | thousandSeprator}}</span>
                                    <v-divider color="#ffffff" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="twitterMetric(post, 'replies') > 0" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Replies</span><br/>
                                    <span class="IG-reaction-value">{{twitterMetric(post, 'replies') | thousandSeprator}}</span>
                                    <v-divider color="#ffffff" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="twitterMetric(post, 'likes') > 0" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{twitterMetric(post, 'likes') | thousandSeprator}}</span>
                                    <v-divider color="#ffffff" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="twitterMetric(post, 'reposts') > 0" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Reposts</span><br/>
                                    <span class="IG-reaction-value">{{twitterMetric(post, 'reposts') | thousandSeprator}}</span>
                                    <v-divider color="#ffffff" width="250px" class="mx-auto"></v-divider>
                                </div>
                                <div v-if="twitterMetric(post, 'bookmarks') > 0" data-aos="fade-right" data-aos-duration="1000" class="text-center">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{twitterMetric(post, 'bookmarks') | thousandSeprator}}</span>
                                    <v-divider color="#ffffff" width="250px" class="mx-auto"></v-divider>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="7" lg="7" align="center">
                            <div v-if="getTwitterEmbedUrl(post.url)" class="twitter-embed-viewport">
                              <iframe
                                class="twitter-post-embed"
                                :src="getTwitterEmbedUrl(post.url)"
                                :title="`X post by ${post.name}`"
                                width="100%"
                                height="560"
                                frameborder="0"
                                scrolling="auto"
                              ></iframe>
                            </div>
                            <v-alert v-else width="500">This X post cannot be embedded.</v-alert>
                            <v-btn small color="secondary" :href="post.url" target="_blank" class="mt-3">
                              View on X
                              <v-icon right>mdi-open-in-new</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
              v-else-if="type === 'others'"
              class="mx-auto"            
              outlined
              color="#000000"
              style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title class="d-flex" style="text-align:center;">
                      <div>{{post.title}} - @{{post.name}} </div>
                    </v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach && post.outreach !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                         
                                <div v-if="post.views !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Views</span><br/>
                                    <span class="IG-reaction-value">{{post.views | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.watches !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Watches</span><br/>
                                    <span class="IG-reaction-value">{{post.watches | thousandSeprator}}s</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.like_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Likes</span><br/>
                                    <span class="IG-reaction-value">{{post.like_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>                                
                                <div v-if="post.comment_count !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Comments</span><br/>
                                    <span class="IG-reaction-value">{{post.comment_count | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.bookmarks !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Bookmarks</span><br/>
                                    <span class="IG-reaction-value">{{post.bookmarks | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.plays !== 0 && post.plays !== '0h:0m:0s'" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                    <span class="IG-reaction-title">Total Play Time</span><br/>
                                    <span class="IG-reaction-value">{{showTikTokPlayTime(post.plays) | thousandSeprator}}</span>
                                    <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                            <div style="max-width:350px;" v-if="post.url">
                              <video width="350" controls v-if="post.media_type === 'video'">
                                <source :src="post.url" type="video/mp4">
                                Your browser does not support HTML5 video.
                              </video>
                              <img style="max-width:350px" v-else-if="post.media_type === 'image'" :src="post.url" />
                              <div style="margin-top:150px;" v-else>
                                <v-alert width="350">
                                  Media type unsupported!
                                </v-alert>
                              </div>
                            </div>
                            <div class="d-flex" style="justify-content:center;margin-top:10px;">
                              <v-btn
                                small
                                color="secondary"
                                @click="download(post.embed_url)"
                                style="margin-right:5px"
                              >
                                Download
                                <v-icon right>mdi-download</v-icon>
                              </v-btn>
                              <v-btn
                                small
                                color="secondary"
                                @click="download(post.postLink)"
                              >
                                View
                                <v-icon right>mdi-file-outline</v-icon>
                              </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card
            v-else-if="type === 'gdrive'"
            class="mx-auto"            
            outlined
            color="#000000"
            style="margin-bottom:50px;border-color:#212121;"
            >
                <v-app-bar
                    dark
                    color="#212121"
                    >
                    <v-toolbar-title style="text-align:center;"><v-icon style="color:#E1306C;" large >mdi-instagram</v-icon>  {{post.title}} - @{{post.name}}</v-toolbar-title>
                </v-app-bar>
                <v-card-text>
                    <v-row align="center" justify="center">
                        <v-col col="12" sm="12" md="6" lg="6">
                            <!-- <div style="color:#fff;font-size:20px;">
                                <v-icon style="color:#E1306C;" large >mdi-instagram</v-icon> {{post.name}}
                            </div>
                            <v-divider color="#E1306C" ></v-divider> -->
                            <div style="margin-top:100px;" >
                                <div v-if="post.outreach && post.outreach !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Audience Size</span><br/>
                                    <span class="IG-reaction-value">{{post.outreach | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.storyTotalInteractions && post.storyTotalInteractions !== 0" data-aos="fade-right" data-aos-duration="1000" style="text-align:center;">
                                  <span class="IG-reaction-title">Total Interactions</span><br/>
                                  <span class="IG-reaction-value">{{post.storyTotalInteractions | thousandSeprator}}</span>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.link_clicks && post.link_clicks !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Link Clicks</span><br/>
                                    <span class="IG-reaction-value">{{post.link_clicks | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.shares && post.shares !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Shares</span><br/>
                                    <span class="IG-reaction-value">{{post.shares | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.replies && post.replies !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Replies</span><br/>
                                    <span class="IG-reaction-value">{{post.replies | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                                <div v-if="post.sticker_taps && post.sticker_taps !== 0">
                                  <div style="text-align:center;">
                                    <span class="IG-reaction-title">Sticker Taps</span><br/>
                                    <span class="IG-reaction-value">{{post.sticker_taps | thousandSeprator}}</span>
                                  </div>
                                  <v-divider color="#E1306C" width="250px" style="margin-left:auto;margin-right:auto;"></v-divider>
                                </div>
                            </div>                            
                        </v-col>
                        <v-col col="12" sm="12" md="6" lg="6" align="center">
                          <!-- <v-card-text class="headline font-weight-bold" v-if="campaignHelper.isAOKCampaign(campaign.campaignType)">
                            <gDrive-post-view :url="post.url" :darkTheme="true" />
                          </v-card-text>
                          <iframe class="media-iframe" width="100%" height="100%" :src="post.url" allowFullScreen v-else></iframe> -->
                          <custom-media
                            :className="getMedia(post).className"
                            :type="getMedia(post).type"
                            :publicID="getMedia(post).publicID"
                            :videoID="getMedia(post).videoID"
                            :URL="getMedia(post).URL"
                            :width="getMedia(post).width"
                            :height="getMedia(post).height"
                            :trans="getMedia(post).trans"
                            :download="true"
                          />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>                                
    </div>
</template>
<script>
import config from '../../config'
import igPostAnalys from '../views/ContentAnalysis/contentAnalysisAPI'
import campaignHelper from '../views/Campaign/campaignHelper';
import GDrivePostView from '../scoped/gdrive/GDrivePostView';
import CustomMedia from '../scoped/custom/CustomMedia';
import BtnDownload from '../scoped/custom/BtnDownload'
export default {
  name: 'rpt_post',
  components: { GDrivePostView, CustomMedia, BtnDownload },
  props: ['type', 'post', 'campaign'],
  data () {
    return {
      post_title: '',
      shortCode: null,
      igPost: null,
      tikTokPost: null,
      youtubePost: null,
      postAnalytics: '',
      postData: {},
      campaignHelper
    }
  },
  computed: {
    POST_TITLE: function() {
      if (this.type === 'story') {
        return 'Instagram Story'
      } else if (this.type === 'post/carousel') {
        return 'Instagram Post/Carousel'
      } else if (this.type === 'tiktok') {
        return 'TikTok'
      }
    },
    POST_URL: function() {
      if (this.post.url.includes('drive.google.com')) { // for google drive link, replace the actual link with preview
        return this.post.url.substr(0, this.post.url.lastIndexOf('/')) + '/preview'
      }
      return this.post.url
    },
    MEDIA_URL_TYPE: function() {
      if (this.type === 'story') {
        const videos = ['mp4', 'MP4', 'mov', 'MOV', '3gp', '3GP', 'ogg', 'OGG', 'mpeg4', 'MPEG4']
        const images = ['jpg', 'JPG', 'jpeg', 'JPEG,', 'gif', 'GIF', 'png', 'PNG', 'svg', 'SVG', 'webp', 'WEBP']
        const url = new URL(this.POST_URL)
        const extension = url.pathname.split('.')[4] // our media url come with long lengh and array[4] only return the extension
        if (videos.includes(extension)) {
          return 'video'
        } else if (images.includes(extension)) {
          return 'image'
        } else if (url.hostname === 'drive.google.com') {
          if (campaignHelper.isAOKCampaign(this.campaign.campaignType)) {
            return 'driveView'
          }
          return 'iframe'
        } else if (url.hostname === 'res.cloudinary.com') {
          return 'cld'
        }
      } else {
        return null
      }
    }
  },
  mounted() {
    if (this.type !== 'story' && this.type !== 'gdrive' && this.type !== 'tiktok' && this.type !== 'youtube' && this.type !== 'linkedin' && this.type !== 'twitter') { // will only generate embed for non story posts and gdrive post links
      this.getInstagramPost(this.POST_URL)
    } else if (this.type === 'youtube') {
      this.youtubePost = campaignHelper.getYoutubePost(this.post.shortCode)
    } else {
      this.tikTokPost = campaignHelper.getTikTokPost(this.post.shortCode)
    }
  },
  watch: {
    post(newPost) {
      this.postData = this.post
    }
  },
  methods: {
    hasPositiveMetric(value) {
      return Number(value) > 0
    },
    twitterMetric(post, metric) {
      const metrics = {
        impressions: post.impressions != null ? post.impressions : post.views,
        replies: post.comment_count,
        likes: post.like_count,
        reposts: post.shares,
        bookmarks: post.saved != null ? post.saved : post.bookmarks
      }
      return Number(metrics[metric]) || 0
    },
    getLinkedInEmbedUrl(postUrl) {
      if (!postUrl || typeof postUrl !== 'string') return ''
      if (/^https:\/\/www\.linkedin\.com\/embed\/feed\/update\//i.test(postUrl)) return postUrl
      let decodedUrl = postUrl
      try {
        decodedUrl = decodeURIComponent(postUrl)
      } catch (error) {
        decodedUrl = postUrl
      }
      const urnMatch = decodedUrl.match(/urn:li:(activity|share|ugcPost):(\d+)/i)
      const publicPostMatch = decodedUrl.match(/\/posts\/[^?#]*-(activity|share|ugcPost)-(\d+)(?:-[^/?#]+)?\/?(?:[?#]|$)/i)
      const postIdentifier = urnMatch || publicPostMatch
      if (!postIdentifier) return ''
      const urnType = postIdentifier[1].toLowerCase() === 'ugcpost' ? 'ugcPost' : postIdentifier[1].toLowerCase()
      return `https://www.linkedin.com/embed/feed/update/urn:li:${urnType}:${postIdentifier[2]}`
    },
    getTwitterEmbedUrl(postUrl) {
      if (!postUrl || typeof postUrl !== 'string') return ''
      const statusMatch = postUrl.match(/(?:x\.com|twitter\.com)\/(?:#!\/)?[^/?#]+\/status(?:es)?\/(\d+)/i)
      return statusMatch ? `https://platform.twitter.com/embed/Tweet.html?id=${statusMatch[1]}&theme=dark` : ''
    },
    getInstagramPost: function(igUrl) {
      let shortCode = ''
      if (igUrl.indexOf('https://www.instagram.com/p/') !== -1) {
        let regex = config.regexPattern.instagram
        if (igUrl.match(regex)) {
          let searchShortCodes = regex.exec(igUrl)
          shortCode = searchShortCodes[1]
        }
      } else if (igUrl.indexOf('https://www.instagram.com/reel/') !== -1) {
        let regex = config.regexPattern.instagram_reel
        if (igUrl.match(regex)) {
          let searchShortCodes = regex.exec(igUrl)
          shortCode = searchShortCodes[1]
        }
      } else if (igUrl.indexOf('https://www.instagram.com/tv/') !== -1) {
        let regex = config.regexPattern.instagram_tv
        if (igUrl.match(regex)) {
          let searchShortCodes = regex.exec(igUrl)
          shortCode = searchShortCodes[1]
        }
      }
      if (shortCode.trim().length === 0) {
        // this.$swal({
        //   title: 'Error',
        //   text: 'Please Input a valid URL',
        //   type: 'error'
        // })
      } else {
        igPostAnalys.oembedOpen(shortCode).then((data) => {
          this.igPost = data.oembed
          setTimeout(() => {
            window.instgrm.Embeds.process()
          }, 100)
        }).catch(() => {
          this.igPost = ''
        })
      }
    },
    showTikTokPlayTime(time) {
      return campaignHelper.showTikTokPlayTime(time)
    },
    getMedia(post) {
      if (post.type === 'gdrive') {
        post.isMultipleContents = true
        post.embed_url = post.url
        post.htmlReport = true
      } else if (post.type === 'story') {
        post.embed_url = post.url
      } else if (post.type === 'others') {
        post.embed_url = post.url
      }
      return campaignHelper.customMediaConfig(post, this.campaign.campaignType)
    },
    getFbPost(url) {
      return `https://www.facebook.com/plugins/post.php?href=${url}&show_text=true&width=500`
    },
    download(url) {
      if (!url) return
      // this.loading = true
      // try {
      //   await utils.func.downloadFile(url.split('/').pop(), url)
      //   this.loading = false
      // } catch (error) {
      //   this.loading = false
      // }
      // url = url.replace('.mp4', '.mov') // replace mp4 to mov to prevent browser from opening new tab
      var link = document.createElement('a');
      link.href = url;
      link.download = url.substr(url.lastIndexOf('/') + 1);
      link.target = '_blank'
      link.click();
    }
  }
}
</script>
<style lang="css" scoped>
.IG-reaction-title {
  color:#fff;
  font-size:20px;
  font-weight:600;
}

.IG-reaction-value {
  font-size:40px;
  font-weight:800;
  line-height:50px;
  color:#E1306C;
}
.media-iframe {
  box-sizing: content-box;
  width: 350px;
  border-radius: 2%;
  border: 1px solid #fff;
}

.linkedin-insights {
  display: flex;
  min-height: 420px;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
}

.linkedin-insights .IG-reaction-value {
  color: #0A66C2;
}

.twitter-insights {
  display: flex;
  min-height: 420px;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
}

.twitter-insights .IG-reaction-value {
  color: #fff;
}

.linkedin-post-embed {
  display: block;
  width: 100%;
  max-width: 640px;
  min-height: 560px;
  border: 0;
  border-radius: 4px;
  background: #fff;
}

.twitter-report-card {
  width: min(1120px, calc(100% - 32px));
  margin-bottom: 50px;
  overflow: hidden;
  border: 1px solid #2f3336 !important;
  border-radius: 12px !important;
}

.twitter-report-title {
  min-width: 0;
  max-width: 100%;
}

.twitter-report-title-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.twitter-report-content {
  padding: 24px !important;
}

.twitter-report-layout {
  max-width: 1040px;
  margin: 0 auto;
}

.twitter-metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  align-content: center;
}

.twitter-metric {
  display: flex;
  min-height: 104px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 10px;
  border: 1px solid #2f3336;
  border-radius: 10px;
  background: #16181c;
}

.twitter-metric-wide {
  grid-column: 1 / -1;
}

.twitter-metric-label {
  color: #8b98a5;
  font-size: 13px;
  font-weight: 600;
}

.twitter-metric-value {
  margin-top: 4px;
  color: #f2f2f2;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
}

.twitter-embed-column {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.twitter-embed-panel {
  width: 100%;
  max-width: 550px;
  height: 500px;
  overflow: hidden;
  border: 1px solid #2f3336;
  border-radius: 10px;
  background: #000;
}

.twitter-post-embed {
  display: block;
  width: calc(100% + 22px);
  max-width: none;
  margin-right: -18px;
  min-height: 560px;
  border: 0;
  background: #fff;
}

.twitter-embed-viewport {
  width: 100%;
  max-width: 550px;
  overflow: hidden;
  border-radius: 4px;
  background: #fff;
}

.twitter-embed-alert {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.twitter-view-button {
  text-transform: none;
}


.twitter-post-embed{
  background-color: #000 !important;
}

@media (max-width: 767px) {
  .media-iframe {
    width: 290px;
  }

  .twitter-report-card {
    width: calc(100% - 16px);
  }

  .twitter-report-content {
    padding: 12px !important;
  }

  .twitter-metric {
    min-height: 86px;
  }

  .twitter-embed-panel {
    height: 420px;
  }
}
</style>



// WEBPACK FOOTER //
// posts.vue?460a37fc